import getSortByFolderId from 'owa-mail-folder-store/lib/selectors/getSortByFolderId';
import { createMailFolderTableQuery } from 'owa-mail-list-actions';
import { getListViewTypeForFolder } from 'owa-mail-list-store';
import TableView from 'owa-mail-list-store/lib/store/schema/TableView';
import { getTableViewFromTableQuery } from 'owa-mail-table-loading-actions';
import FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import InboxClassificationFilter from 'owa-mail-inbox-plus-store/lib/store/schema/InboxClassificationFilter';

export function getInboxTableView(
    focusedViewFilter: FocusedViewFilter,
    inboxClassificationFilter?: InboxClassificationFilter
): TableView {
    const inboxFolderId = folderNameToId('inbox');
    const tableQuery = createMailFolderTableQuery(
        inboxFolderId,
        getListViewTypeForFolder(inboxFolderId),
        'mail',
        focusedViewFilter,
        null /* viewFilter */,
        null /* categoryName */,
        getSortByFolderId(inboxFolderId),
        inboxClassificationFilter
    );

    return getTableViewFromTableQuery(tableQuery);
}
